import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '400px',
        borderRadius: '8px',
      },
    },
  ],
})`
  margin-top: 8px;
`;
